import { render, staticRenderFns } from "./employeeComplaintForm.vue?vue&type=template&id=4202a8c8&scoped=true"
import script from "./employeeComplaintForm.vue?vue&type=script&lang=js"
export * from "./employeeComplaintForm.vue?vue&type=script&lang=js"
import style0 from "./employeeComplaintForm.vue?vue&type=style&index=0&id=4202a8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4202a8c8",
  null
  
)

export default component.exports